// extracted by mini-css-extract-plugin
export default {"content":"SalaryRights_content__uF3-6","contentValue":"SalaryRights_contentValue__YR9Mq"};